module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idgenobjectstyleoverride",
    attrs: {
      "id": "_idContainer1347"
    }
  }, [_c('p', {
    staticClass: "structure-bnxt",
    attrs: {
      "id": "calibre_pb_5"
    }
  }, [_c('img', {
    staticClass: "_idgenobjectattribute3",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/Artwork_1131.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph1"
  }, [_c('span', {
    staticClass: "charoverride"
  }, [_vm._v("by")]), _c('span', {
    staticClass: "charoverride"
  }), _c('img', {
    staticClass: "_idgenobjectattribute1",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/Artwork_114.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph2"
  }, [_c('span', {
    staticClass: "charoverride1"
  }, [_vm._v("50 Easy & Tasty Recipes Using"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("the Best Ingredients"), _c('br', {
    staticClass: "calibre2"
  }), _vm._v("from the Grocery Store")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph3"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Bobby Parrish and Dessi Parrish")])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph4"
  }, [_c('span', {
    staticClass: "charoverride2"
  }, [_c('img', {
    staticClass: "_idgenobjectattribute4",
    attrs: {
      "alt": "",
      "src": "OEBPS/image/Mango_Publishing_Group.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "basic-paragraph5",
    attrs: {
      "id": "calibre_pb_6"
    }
  }, [_c('span', {
    staticClass: "charoverride3"
  }, [_vm._v("Coral Gables")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e44574f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/5Ingredient_split_002.vue
// module id = 63
// module chunks = 0